import PropTypes from "prop-types";
import { memo } from "react";
import { RESOLUTION } from "app/pages/.shared/responsive/responsiveReducer";
import { addOptionsToCloundinaryURL } from "app/utils/image/cloudinaryUtils";
import "./SwiperLazyBackgroundImage.scss";

const MAX_WIDTHS = {
	small: 768,
	medium: 978,
	large: 1440,
	xlarge: 1440,
};

const SwiperLazyBackgroundImage = ({
	sizes,
	resolution,
	backgroundPosition,
	src,
	quality,
	cloudinaryOptions,
}) => {
	const cloudinarify = () => {
		let cloudinaryConfig = [];

		const size = sizes && sizes[resolution];

		if (size && size.width) {
			cloudinaryConfig.push(`w_${size.width}`);
		} else {
			cloudinaryConfig.push(`w_${MAX_WIDTHS[resolution]}`);
		}

		if (size && size.height) {
			cloudinaryConfig.push(`h_${size.height}`);
		}

		if (src) {
			return addOptionsToCloundinaryURL(src, cloudinaryConfig.concat(cloudinaryOptions), {
				quality,
			});
		}

		return "";
	};

	const source = cloudinarify();

	const imgStyle = {
		width: "100%",
		height: "100%",
		objectFit: "cover",
		objectPosition: backgroundPosition,
		display: "block",
	};

	return (
		resolution !== RESOLUTION.UNKNOWN &&
		sizes[resolution] !== undefined && (
			<img
				className="simple-background-progressive-image"
				data-testid="simple-background-progressive-image"
				loading="lazy"
				src={source}
				alt=""
				style={imgStyle}
			/>
		)
	);
};

SwiperLazyBackgroundImage.defaultProps = {
	backgroundPosition: "center",
	sizes: {},
};

SwiperLazyBackgroundImage.propTypes = {
	src: PropTypes.string,
	sizes: PropTypes.shape({
		small: PropTypes.shape({
			height: PropTypes.number,
			width: PropTypes.number,
		}),
		medium: PropTypes.shape({
			height: PropTypes.number,
			width: PropTypes.number,
		}),
		large: PropTypes.shape({
			height: PropTypes.number,
			width: PropTypes.number,
		}),
		xlarge: PropTypes.shape({
			height: PropTypes.number,
			width: PropTypes.number,
		}),
	}),
	resolution: PropTypes.string,
	backgroundPosition: PropTypes.string,
	cloudinaryOptions: PropTypes.arrayOf(PropTypes.string),
	quality: PropTypes.string,
};

export default memo(SwiperLazyBackgroundImage);
